import Selector_vue_vue_type_script_setup_true_lang_default from "./Selector.vue.script.js";
//#region src/components/Selector.vue
var Selector_default = Selector_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { Selector_default as default };

//# sourceMappingURL=Selector.vue.js.map